import { useCallback, useEffect } from 'react';
import { getPagePathname } from '../getPagePathname';
import { EventDetails, EventNames } from '../../types';
import { useNavigate } from 'react-router-dom';

type Args = {
  pageId: string | undefined;
  pageInputs?: Record<string, unknown>;
};

export const useHandleGoToPageEvent = ({ pageId, pageInputs }: Args) => {
  const navigate = useNavigate();

  const handleUpdatePageEvent = useCallback(
    (event: CustomEvent<EventDetails[typeof EventNames.GoToPage]>) => {
      // This event will be triggered only when one of pageId or pageInputs are changed
      const pathname = getPagePathname({
        // If pageId is not defined, use current pageId
        pageId: event.detail.pageId || pageId,
        // If pageInputs is not defined, use current pageInputs
        pageInputs: event.detail.pageInputs || pageInputs,
      });

      if (pathname) {
        navigate(pathname, { replace: true });
      }
    },
    [navigate, pageId, pageInputs],
  );

  useEffect(() => {
    window.addEventListener(EventNames.GoToPage, handleUpdatePageEvent);
    return () => {
      window.removeEventListener(EventNames.GoToPage, handleUpdatePageEvent);
    };
  }, [handleUpdatePageEvent]);
};
